module.exports = __webpack_public_path__ + "e8012458a5a21fd2d9605f050332461e.svg";